import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addStakeholderGroupData = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdergroup`,
    data,
  );
  return response.data;
};

export const updateStakeholderGroupData = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdergroup`,
    data,
  );
  return response.data;
};

export const getStakeholderGroupData = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdergroup/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const searchStakeholderGroup = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdergroup/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const getStakeholderGroupDataById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdergroup/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
